// Used overall the app but interestPercentage is used for customized percentageInterest from api options
export const promoPriceToSRP = (
  num: number | undefined | null,
  percentageInDecimal = 0.12
) => {
  let retailPrice = num || 0;
  const toAddIfSRP = retailPrice * percentageInDecimal;

  return retailPrice + toAddIfSRP;
};

// Used overall the app but interestPercentage is used for customized percentageInterest from api options
export const promoPriceDiscounted = (
  num: number | undefined | null,
  percentageInDecimal = 0.12
) => {
  const retailPrice = num || 0;
  return retailPrice * percentageInDecimal;
};

export const isValidCurrency = (amount: string) => {
  return true;
};

export const formatCurrency = (
  amount: any,
  // eslint-disable-next-line no-unused-vars
  symbol: string = "₱",
  decimal = 2,
  // extraOptions?: ExtraOptionsType
  extraOptions?: Record<string, unknown>
) => {
  // Sometimes, 'strings' can still pass amount type.
  // and will error TypeError: amount.toFixed is not a function
  // in that case convert amount params type into number
  if (typeof amount !== "number") {
    if (isValidCurrency(amount)) {
      formatCurrency(+amount);
    } else {
      return "";
    }
  }
  if (amount === null || amount === undefined) {
    return "";
  }
  // Create our number formatter.
  const formatter = new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    minimumFractionDigits: decimal,
    ...extraOptions,
  });

  let currencyInStr = `${formatter.format(amount)}`;
  if (extraOptions?.removeCurrency) {
    currencyInStr = currencyInStr.substring(1);
  }

  return currencyInStr;
};

export const formatCurrencySRP = (amount: number) => {
  return formatCurrency(promoPriceToSRP(amount));
};

export const toTitleCase = (str: string) => {
  return str?.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const onCopyText = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const currencyToNumber = (str?: string) => {
  return Number(str?.replace(/[^0-9.-]/g, ""));
};

export const productDetailsPageUrl = (slug?: string, product_uuid?: string) => {
  // Old Version
  // return `/product/${slug}${product_uuid ? `?q=${product_uuid}` : ""}`;

  // New Version
  return `/product/${product_uuid}${slug ? `?slug=${slug}` : ""}`;
};

export const isInputUuidOrSlug = (input: string) => {
  const shortUuidRegex = /^[0-9a-f]{8}$/i; // 8-character hex UUID
  const longHexIdRegex = /^[0-9a-f]{12}$/i; // 12-character hex ID
  const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/; // SEO-friendly slug

  if (shortUuidRegex.test(input) || longHexIdRegex.test(input)) {
    return "uuid";
  } else if (slugRegex.test(input)) {
    return "slug";
  } else {
    return "unknown";
  }
};

export const slugToNameUtil = (slug: string) => {
  const parts = slug.split("-");

  const formattedParts = parts.map((part) => {
    return part.toUpperCase();
  });

  const formattedSlug = formattedParts.join(" ");

  return formattedSlug;
};

export const standardizeMobileNumber = (input: string) => {
  // Remove non-digit characters
  let digits: string | null = input?.replace(/\D/g, "");

  // Check the length and format
  if (digits?.length === 10 && digits?.startsWith("9")) {
    // If it's 10 digits, add '63' at the beginning
    digits = "63" + digits;
  } else if (digits?.length === 11 && digits?.startsWith("0")) {
    // If it's 11 digits and starts with '0', replace '0' with '63'
    digits = "63" + digits?.substring(1);
  } else if (digits?.length !== 12) {
    // If the length is not 10, 11, or 12, return an error message or handle accordingly
    digits = null;
  }

  return digits;
};

// Robust decoding to handle characters that aren't part of the ASCII range (like ™, é, etc.).
export const decodeContent = (val: string) => {
  const decodedData = new TextDecoder().decode(
    new Uint8Array(
      atob(val)
        .split("")
        .map((c) => c.charCodeAt(0))
    )
  );
  return decodedData;
};

export const modifyContentWithRegex = (
  htmlString: string,
  isMobile: boolean
) => {
  //regex hard :<<<<<<<
  return htmlString.replace(
    /<img[^>]*\balt\s*=\s*["']button["'][^>]*>/gi,
    (match) => {
      // Modify styles for the matched img tag
      const updatedImg = match
        .replace(/height:\s*auto;?/gi, "") // Remove height: auto;
        .replace(/width:\s*auto;?/gi, ""); // Remove width: auto;

      // Add new styles
      const newStyle = `width: ${
        isMobile ? "100%" : "auto"
      }; transform: scale(1); height: auto;`;
      return updatedImg.replace(/style="[^"]*"/, `style="${newStyle}"`);
    }
  );
};

export const convertToSlug = (slug: string) => {
  return slug
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9\-]/g, "");
};
